<template>
  <div class="process-status-form">
    <pt-form-item label="是否合格" labelWidth="100px" :required="true">
        <el-radio-group v-model="statusForm.result" name="result" v-validate="'required'" data-vv-as="是否合格">
					<el-radio label="QUALIFIED">合格</el-radio>
					<el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
				</el-radio-group>
    </pt-form-item>
    <template v-if="statusForm.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'">
      <pt-form-item label="原因" labelWidth="100px" :required="true">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" name="reason" data-vv-as="原因" v-validate="'required'" v-model="statusForm.reason" class="texta" placeholder="请填写原因" @mousedown.stop.native @click.stop.native></el-input>
          <!-- <sample-receive-reason name="reason" data-vv-as="原因" v-validate="'required'" v-model="statusForm.reason" @mousedown.stop.native @click.stop.native></sample-receive-reason> -->
      </pt-form-item>
    </template>
    <pt-form-item label="备注" labelWidth="100px">
        <el-input  type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="statusForm.comment" class="texta" placeholder="选填" @mousedown.stop.native @click.stop.native></el-input>
    </pt-form-item>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// import sampleReceiveReason from '../sample-receive-reason'
// 组件class前缀
const prefixCls = 'pt-lab-samples-received-form'

export default {
  name: 'pt-lab-samples-received-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      statusForm: JSON.stringify(this.value) !== '{}' ? this.value : {
        result: 'QUALIFIED',
        reason: '',
        comment: ''
      }
    }
  },
  // components: {
  //   sampleReceiveReason
  // },
  watch: {
    statusForm: {
      handler: function (val, oldVal) {
        this.$emit('input', val)
      },
      deep: true
    },
    value (val) {
      this.statusForm = JSON.stringify(val) !== '{}' ? val : {
        result: 'QUALIFIED',
        reason: ''
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.process-status-form{
  margin:20px 0;
   el-textarea,.el-textarea__inner{
    width:500px;
  }
}
</style>
